export const DISCARDED_CALCULATION_REQUEST_MESSAGE =
  'DISCARDED_CALCULATION_REQUEST'
